import "./RealEstateTransactions.module.css";
import RealEstateHero from "./sections/RealEstateHero";
import Footer from "@/reusable_sections/Footer";
import ContractsAndTransitions from "./sections/ContractsAndTransitions";
import CommercialRealEstate from "./sections/CommercialRealEstate";
import ResidentialRealEstate from "./sections/ResidentialRealEstate";
import Mainheader from "./sections/Mainheader";
export default function RealEstateTransactionsPage() {
  return <div>
      <Mainheader />
      <RealEstateHero />
      <CommercialRealEstate />
      <ResidentialRealEstate />
      <ContractsAndTransitions />
      <Footer />
    </div>;
}